module.exports = __webpack_public_path__ + "img/ico-tools-equipments.daad1938.svg";